import {
  CuratedBox,
  TopInStockRecipe,
} from '../Components/CuratedBoxRecipeTile/CuratedBoxRecipeTile'

const recipesPerPortions = {
  1: 5,
  2: 5,
  3: 5,
  4: 4,
  5: 3,
}

type PrepTimes = {
  [key: string]: number
}

export type CuratedBoxesRecipesType = {
  relationships: {
    recipes: { data: { core_recipe_id: string }[] }
    collection: { data: Record<string, string>[] }
  }
  type: string
  id: string
  attributes: { title: string; tags: string[] }
}[]

export type AllRecipesType = {
  [key: string]: {
    coreRecipeId: string
    media: { images: { urls: { src: string }[] }[] }
    title: string
    prepTimes: PrepTimes
  }
}

export const getCuratedBoxesRecipes = (
  allRecipes: AllRecipesType,
  curatedBoxesRecipes: CuratedBoxesRecipesType,
  isRecipeOutOfStock: (id: string) => boolean,
  numPortions: keyof typeof recipesPerPortions,
): CuratedBox[] => {
  const numRecipes = recipesPerPortions[numPortions]

  return curatedBoxesRecipes?.map((curatedBox) => {
    const topInStockRecipes = curatedBox.relationships.recipes?.data.map(
      ({ core_recipe_id: id }: { core_recipe_id: string }) => {
        if (isRecipeOutOfStock(id)) return

        const prepTimesKey = `for${numPortions.toString()}`

        const prepTimePerPortion = allRecipes[id]?.prepTimes[prepTimesKey]

        return {
          recipeId: allRecipes[id]?.coreRecipeId,
          recipeImageSrc: allRecipes[id]?.media?.images[0]?.urls[1]?.src,
          title: allRecipes[id]?.title,
          prepTimes: prepTimePerPortion,
        }
      },
    )
    return {
      type: curatedBox.type,
      id: curatedBox.id,
      curatedBoxCollectionId: curatedBox.relationships.collection.data[0].id,
      title: curatedBox.attributes.title,
      tags: curatedBox.attributes.tags,
      topInStockRecipes: topInStockRecipes
        .filter((recipes) => recipes !== undefined)
        .slice(0, numRecipes) as TopInStockRecipe[],
    }
  })
}
